import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const HEADER_LEFT_CONTAINER_WIDTH = gridSize * 100;
export const STATUS_LOZENGE_WIDTH = gridSize * 12;

export const SIDEBAR_RESIZE_BUTTON_SELECTOR = 'VersionDetailsRightSidebarResizeButton';
